import React from 'react';
import { useTranslation } from 'react-i18next';

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const currentLang = i18n.language;

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    localStorage.setItem('language', lng);
  };

  return (
    <div className="flex items-center h-10 rounded-lg overflow-hidden border-2 border-slate-600/30 dark:border-slate-500/30 backdrop-blur-sm shadow-md hover:shadow-lg transition-all duration-300">
      {/* FR Button */}
      <button
        onClick={() => changeLanguage('fr')}
        className={`flex items-center justify-center gap-1.5 px-3 h-full font-semibold text-sm transition-all duration-300 ${
          currentLang === 'fr'
            ? 'bg-blue-600 text-white'
            : 'bg-slate-200/80 dark:bg-slate-700/50 text-slate-600 dark:text-slate-400 hover:bg-slate-300/90 dark:hover:bg-slate-600/70'
        }`}
        aria-label="Français"
      >
        <span className="text-xl">🇫🇷</span>
        <span>FR</span>
      </button>
      
      {/* Divider */}
      <div className="w-px h-full bg-slate-400/50 dark:bg-slate-600/50" />
      
      {/* EN Button */}
      <button
        onClick={() => changeLanguage('en')}
        className={`flex items-center justify-center gap-1.5 px-3 h-full font-semibold text-sm transition-all duration-300 ${
          currentLang === 'en'
            ? 'bg-[#C97249] text-white'
            : 'bg-slate-200/80 dark:bg-slate-700/50 text-slate-600 dark:text-slate-400 hover:bg-slate-300/90 dark:hover:bg-slate-600/70'
        }`}
        aria-label="English"
      >
        <span className="text-xl">🇺🇸</span>
        <span>EN</span>
      </button>
    </div>
  );
};

export default LanguageSwitcher;
